(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-cart"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      var form = root.querySelector('#PupCartForm');
      var update = root.querySelector('[data-pup-update]');
      if (!form) return;
      var timer;

      function send() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (form.requestSubmit && update) {
            form.requestSubmit(update);
          } else if (update) {
            update.click();
          }
        }, 450);
      }

      root.querySelectorAll('.pup-cart__qty').forEach(function (box) {
        var input = box.querySelector('input');
        box.querySelector('[data-pup-minus]').addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          send();
        });
        box.querySelector('[data-pup-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 0) + 1;
          send();
        });
        input.addEventListener('change', function () {
          input.value = Math.max(0, parseInt(input.value, 10) || 0);
          send();
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-pup-cart]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-classes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('.pup-classes__loc'));
      var items = Array.prototype.slice.call(root.querySelectorAll('.pup-class'));
      var names = root.querySelectorAll('[data-loc-name]');
      var more = root.querySelector('.pup-classes__more [data-more]');
      var empty = root.querySelector('[data-empty]');
      var limit = parseInt(root.dataset.limit, 10) || 0;
      if (!tabs.length) return;

      var current = tabs[0].dataset.loc;
      var expanded = false;

      function matches(li, slug) {
        return li.dataset.loc === slug || li.dataset.loc === '*';
      }

      function countFor(slug) {
        return items.filter(function (li) { return matches(li, slug); }).length;
      }

      function render(slug, animate) {
        var active = tabs.filter(function (t) { return t.dataset.loc === slug; })[0] || tabs[0];
        current = active.dataset.loc;
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === active ? 'true' : 'false');
        });

        var count = 0;
        var shown = 0;
        items.forEach(function (li) {
          var match = matches(li, current);
          var show = false;
          if (match) {
            count++;
            show = !(limit > 0 && count > limit && !expanded);
          }
          li.hidden = !show;
          li.classList.remove('pup-rise-in');
          if (show && animate) {
            void li.offsetWidth;
            li.style.setProperty('--pup-d', Math.min(shown, 8) * 60 + 'ms');
            li.classList.add('pup-rise-in');
          }
          if (show) shown++;
        });

        names.forEach(function (n) { n.textContent = active.dataset.name; });
        if (more) more.hidden = !(limit > 0 && count > limit && !expanded);
        if (empty) empty.hidden = count > 0;
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          expanded = false;
          render(t.dataset.loc, true);
          if (window.history && history.replaceState) {
            history.replaceState(null, '', '#' + t.dataset.loc);
          }
        });
      });

      if (more) {
        more.addEventListener('click', function () {
          expanded = true;
          render(current, true);
        });
      }

      var hash = window.location.hash.replace('#', '');
      var fromHash = tabs.filter(function (t) { return t.dataset.loc === hash; })[0];
      var hint = (root.dataset.hint || '').toLowerCase();
      var fromCollection = tabs.filter(function (t) { return hint.indexOf(t.dataset.loc) !== -1; })[0];
      var firstWithClasses = tabs.filter(function (t) { return countFor(t.dataset.loc) > 0; })[0];
      render((fromHash || fromCollection || firstWithClasses || tabs[0]).dataset.loc, false);
    }

    function boot() {
      document.querySelectorAll('[data-pup-classes]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('.pup-faq__cat'));
      var items = Array.prototype.slice.call(root.querySelectorAll('.pup-faq__item'));
      var eyebrow = root.querySelector('[data-faq-eyebrow]');
      var blurb = root.querySelector('[data-faq-blurb]');
      if (!tabs.length) return;

      function select(slug, push) {
        var active = tabs.filter(function (t) { return t.dataset.cat === slug; })[0] || tabs[0];
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === active ? 'true' : 'false');
        });
        var shown = 0;
        items.forEach(function (d) {
          var match = d.dataset.cat === active.dataset.cat;
          d.hidden = !match;
          if (!match) {
            d.open = false;
            d.classList.remove('pup-rise-in');
          } else {
            d.classList.remove('pup-rise-in');
            void d.offsetWidth;
            d.style.setProperty('--pup-d', Math.min(shown, 8) * 45 + 'ms');
            d.classList.add('pup-rise-in');
            shown++;
          }
        });
        if (eyebrow) eyebrow.textContent = active.dataset.name;
        if (blurb) blurb.textContent = active.dataset.blurb || '';
        if (push && window.history && history.replaceState) {
          history.replaceState(null, '', '#' + active.dataset.cat);
        }
        if (active.scrollIntoView && window.matchMedia('(max-width: 989px)').matches) {
          active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t.dataset.cat, true); });
      });

      var hash = window.location.hash.replace('#', '');
      if (hash) select(hash, false);
    }

    function boot() {
      document.querySelectorAll('[data-pup-faq]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-header"]) return;
  try {
    
  (function () {
    function init(header) {
      if (header.dataset.pupReady) return;
      header.dataset.pupReady = 'true';

      var html = document.documentElement;
      var btn = header.querySelector('[data-pup-open]');
      var drawer = header.querySelector('[data-pup-drawer]');
      var overlay = header.querySelector('[data-pup-overlay]');
      var closeBtn = header.querySelector('[data-pup-close]');
      if (!btn || !drawer || !overlay) return;

      function isOpen() {
        return btn.getAttribute('aria-expanded') === 'true';
      }

      function open() {
        drawer.removeAttribute('inert');
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'Close menu');
        html.classList.add('pup-lock');
        window.setTimeout(function () {
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        }, 60);
      }

      function close(returnFocus) {
        if (!isOpen()) return;
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open menu');
        html.classList.remove('pup-lock');
        drawer.setAttribute('inert', '');
        if (returnFocus) btn.focus({ preventScroll: true });
      }

      btn.addEventListener('click', function () {
        if (isOpen()) close(true);
        else open();
      });
      if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
      overlay.addEventListener('click', function () { close(true); });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { close(false); });
      });

      document.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') {
          close(true);
          return;
        }
        if (e.key !== 'Tab') return;
        var items = drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      var wide = window.matchMedia('(min-width: 1100px)');
      var onWide = function (e) { if (e.matches) close(false); };
      if (wide.addEventListener) wide.addEventListener('change', onWide);

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > 8);
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function boot() {
      document.querySelectorAll('[data-pup-header]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-icons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var phone = window.matchMedia('(max-width: 749px)');

    function init(list) {
      if (list.dataset.pupReady) return;
      list.dataset.pupReady = 'true';

      var items = list.querySelectorAll('.pup-icons__item');
      var dots = list.parentElement.querySelector('[data-pup-dots]');
      var seconds = parseFloat(list.dataset.seconds) || 2;
      var timer = null;
      var resumeTimer = null;
      var visible = true;
      var index = 0;

      if (dots) {
        for (var i = 0; i < items.length; i++) {
          var d = document.createElement('span');
          d.className = 'pup-icons__dot';
          dots.appendChild(d);
        }
      }

      function current() {
        var w = list.clientWidth || 1;
        return Math.max(0, Math.min(items.length - 1, Math.round(list.scrollLeft / w)));
      }

      function paint() {
        if (!dots) return;
        Array.prototype.forEach.call(dots.children, function (dot, n) {
          dot.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      function goTo(n) {
        list.scrollTo({ left: n * list.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      function restart() {
        list.style.transition = 'opacity 0.2s ease';
        list.style.opacity = '0';
        window.setTimeout(function () {
          list.scrollTo({ left: 0, behavior: 'auto' });
          list.style.opacity = '1';
        }, 230);
      }

      function tick() {
        if (!phone.matches || !visible || document.hidden) return;
        var now = current();
        if (now >= items.length - 1) restart();
        else goTo(now + 1);
      }

      function start() {
        stop();
        if (reduce || items.length < 2) return;
        timer = window.setInterval(tick, seconds * 1000);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function userTouched() {
        stop();
        if (resumeTimer) window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, 5000);
      }

      list.addEventListener('scroll', function () {
        var n = current();
        if (n !== index) {
          index = n;
          paint();
        }
      }, { passive: true });

      ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
        list.addEventListener(evt, userTouched, { passive: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
        }, { threshold: 0.3 }).observe(list);
      }

      paint();
      start();
    }

    function boot() {
      document.querySelectorAll('[data-pup-slider]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-login"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';
      root.classList.add('is-ready');

      var signin = root.querySelector('[data-pup-signin]');
      var recover = root.querySelector('[data-pup-recover]');
      var sent = root.querySelector('[data-pup-recover-sent]');
      if (!signin || !recover) return;

      function show(which, focus) {
        var rec = which === 'recover';
        recover.hidden = !rec;
        signin.hidden = rec;
        if (focus) {
          var target = (rec ? recover : signin).querySelector('input');
          if (target) target.focus({ preventScroll: false });
        }
      }

      root.querySelectorAll('[data-pup-show-recover]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); show('recover', true); });
      });
      root.querySelectorAll('[data-pup-show-signin]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); show('signin', true); });
      });

      show(sent || window.location.hash === '#recover' ? 'recover' : 'signin', false);
    }

    function boot() {
      document.querySelectorAll('[data-pup-login]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-more-ways"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(stage) {
      if (stage.dataset.pupReady) return;
      stage.dataset.pupReady = 'true';

      var track = stage.querySelector('[data-pup-track]');
      var dots = stage.querySelector('[data-pup-dots]');
      if (!track || !dots) return;

      var cards = track.querySelectorAll('.pup-more__card');
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'pup-more__dot';
        dots.appendChild(dot);
      }

      function step() {
        var card = cards[0];
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function sync() {
        var index = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step())));
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function boot() {
      document.querySelectorAll('[data-pup-more]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-product"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      var stage = root.querySelector('#PupStage');
      var thumbs = root.querySelectorAll('.pup-product__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!stage) return;
          stage.removeAttribute('srcset');
          stage.removeAttribute('sizes');
          stage.src = t.dataset.large;
          thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });

      var qty = root.querySelector('input[name="quantity"]');
      var minus = root.querySelector('[data-pup-minus]');
      var plus = root.querySelector('[data-pup-plus]');
      function clamp(n) {
        var max = qty ? parseInt(qty.max, 10) || 99 : 99;
        return Math.max(1, Math.min(max, n));
      }
      if (qty && minus && plus) {
        minus.addEventListener('click', function () { qty.value = clamp((parseInt(qty.value, 10) || 1) - 1); });
        plus.addEventListener('click', function () { qty.value = clamp((parseInt(qty.value, 10) || 1) + 1); });
        qty.addEventListener('change', function () { qty.value = clamp(parseInt(qty.value, 10) || 1); });
      }

      var giftBox = root.querySelector('[data-pup-gift]');
      if (giftBox) {
        var toggle = giftBox.querySelector('[data-pup-gift-toggle]');
        var control = giftBox.querySelector('[data-pup-gift-control]');
        var fields = giftBox.querySelector('[data-pup-gift-fields]');
        var offset = giftBox.querySelector('[data-pup-offset]');
        var gInputs = fields.querySelectorAll('input, textarea');
        var gEmail = fields.querySelector('input[type="email"]');
        var gDate = fields.querySelector('input[type="date"]');
        toggle.disabled = false;
        control.disabled = true;
        offset.value = String(new Date().getTimezoneOffset());
        if (gDate) gDate.min = new Date().toISOString().slice(0, 10);

        var syncGift = function () {
          var on = toggle.checked;
          fields.hidden = !on;
          gInputs.forEach(function (i) {
            i.disabled = !on;
            if (!on) i.value = '';
          });
          offset.disabled = !on;
          if (gEmail) gEmail.required = on;
        };
        toggle.addEventListener('change', syncGift);
        syncGift();
      }

      var select = root.querySelector('[data-pup-variants]');
      var price = root.querySelector('[data-pup-price]');
      var submit = root.querySelector('[data-pup-submit]');
      var text = root.querySelector('[data-pup-submit-text]');
      var waitlist = root.querySelector('[data-pup-waitlist]');
      function setFact(name, value) {
        var li = root.querySelector('[data-pup-fact="' + name + '"]');
        if (!li) return;
        var span = li.querySelector('[data-pup-fact-text]');
        li.hidden = !value;
        if (span) span.textContent = value || '';
      }

      function formatDate(iso) {
        if (!iso) return '';
        var d = new Date(iso + 'T12:00:00');
        if (isNaN(d.getTime())) return iso;
        return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      }

      var ticketsEl = root.querySelector('[data-pup-tickets]');

      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (price) price.textContent = opt.dataset.price;
          if (ticketsEl && opt.dataset.tickets) ticketsEl.textContent = opt.dataset.tickets;
          if (select.dataset.dateVariants === 'true') {
            setFact('date', formatDate(opt.dataset.date));
            setFact('time', opt.dataset.time);
            setFact('venue', opt.dataset.venue);
          }
          if (window.history && history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', opt.value);
            history.replaceState(null, '', u.toString());
          }
          var ok = opt.dataset.available === 'true';
          submit.disabled = !ok;
          text.textContent = ok ? submit.dataset.label : submit.dataset.soldOut;
          if (waitlist) waitlist.hidden = ok;
        });
      }
    }

    function boot() {
      document.querySelectorAll('[data-pup-product]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var phone = window.matchMedia('(max-width: 749px)');

    function smooth(t) {
      return t * t * (3 - 2 * t);
    }

    function init(root) {
      if (root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      var runway = root.querySelector('[data-pup-runway]');
      var pin = root.querySelector('[data-pup-pin]');
      var track = root.querySelector('[data-pup-track]');
      var dotsBox = root.querySelector('[data-pup-dots]');
      if (!runway || !pin || !track) return;

      var n = track.children.length;
      if (n < 2) return;

      var per = parseFloat(root.dataset.perStep) || 300;
      var active = false;
      var stick = 0;
      var dist = 0;
      var frame = 0;
      var lastIndex = -1;
      var lastWidth = window.innerWidth;

      for (var i = 0; i < n; i++) {
        var dot = document.createElement('span');
        dot.className = 'pup-steps__dot';
        dotsBox.appendChild(dot);
      }

      function headerHeight() {
        var h = document.querySelector('.shopify-section-group-header-group');
        return h ? h.getBoundingClientRect().height : 0;
      }

      function paintDots(index) {
        if (index === lastIndex) return;
        lastIndex = index;
        Array.prototype.forEach.call(dotsBox.children, function (d, k) {
          d.setAttribute('aria-current', k === index ? 'true' : 'false');
        });
      }

      function disable() {
        active = false;
        root.classList.remove('is-scrub');
        runway.style.height = '';
        pin.style.top = '';
        track.style.removeProperty('--pup-x');
        lastIndex = -1;
      }

      function measure() {
        stick = headerHeight();
        root.classList.add('is-scrub');
        runway.style.height = 'auto';
        pin.style.top = stick + 'px';

        var pinHeight = pin.getBoundingClientRect().height;
        if (pinHeight > window.innerHeight - stick) {
          disable();
          return false;
        }

        dist = per * (n - 1);
        runway.style.height = pinHeight + dist + 'px';
        active = true;
        return true;
      }

      function update() {
        frame = 0;
        if (!active) return;

        var runwayTop = runway.getBoundingClientRect().top;
        var p = Math.max(0, Math.min(1, (stick - runwayTop) / dist));

        var f = p * (n - 1);
        var base = Math.min(n - 1, Math.floor(f));
        var frac = base >= n - 1 ? 0 : f - base;
        var eased = frac < 0.3 ? 0 : frac > 0.7 ? 1 : smooth((frac - 0.3) / 0.4);
        var x = base + eased;

        track.style.setProperty('--pup-x', x.toFixed(4));
        paintDots(Math.round(x));
      }

      function schedule() {
        if (!frame) frame = window.requestAnimationFrame(update);
      }

      function evaluate() {
        if (phone.matches && !reduce) {
          if (measure()) update();
        } else {
          disable();
        }
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        evaluate();
      });
      if (phone.addEventListener) phone.addEventListener('change', evaluate);
      window.addEventListener('load', evaluate);

      evaluate();
    }

    function boot() {
      document.querySelectorAll('[data-pup-steps]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-pup-track]');
      var dots = root.querySelector('[data-pup-dots]');
      var prev = root.querySelector('[data-pup-prev]');
      var next = root.querySelector('[data-pup-next]');
      if (!track || root.dataset.pupReady) return;
      root.dataset.pupReady = 'true';

      function step() {
        var card = track.querySelector('.pup-testi__card');
        return card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      }

      function pages() {
        return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
      }

      function build() {
        dots.textContent = '';
        for (var i = 0; i < pages(); i++) {
          var d = document.createElement('span');
          d.className = 'pup-testi__dot';
          dots.appendChild(d);
        }
        update();
      }

      function update() {
        var i = Math.round(track.scrollLeft / step());
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', build);
      build();
    }

    function boot() {
      document.querySelectorAll('[data-pup-testi]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
